import { GridColDef } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Switch, Tooltip } from "@mui/material";
import ActionButton from "../action-button";
import { ClaimType, ClientInformation } from "./types";

export const getColumns = ({
  onEdit,
  onDelete,
  onToggleMappingComplete,
}: {
  onEdit: (row: ClientInformation) => void;
  onDelete: (row: ClientInformation) => void;
  onToggleMappingComplete?: (row: ClientInformation) => void;
}): GridColDef[] => [
  {
    field: "id",
    headerName: "ID",
  },
  { field: "name", headerName: "Name", flex: 1 },
  {
    field: "claimType",
    headerName: "Claim Type",
    type: "string",
    flex: 1,
    valueGetter: (value: ClaimType) => value?.description ?? "",
  },
  {
    field: "type",
    headerName: "Type",
    type: "string",
    flex: 1,
    valueGetter: (value: ClaimType) => value?.description ?? "",
  },
  {
    field: "dateCreated",
    headerName: "Created date",
    type: "date",
    valueGetter: (value: string) => value && new Date(value),
    width: 160,
  },
  {
    field: "enabled",
    headerName: "Enabled",
    maxWidth: 120,
    type: "boolean",
    flex: 1,
  },
  {
    field: "deleted",
    headerName: "Deleted",
    maxWidth: 120,
    type: "boolean",
    flex: 1,
  },
  {
    field: "mappingComplete",
    headerName: "Mapping Complete",
    maxWidth: 180,
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <Tooltip
        title={
          params.row.mappingComplete
            ? "Click to mark as incomplete"
            : "Click to mark as complete"
        }
        placement="top"
      >
        <Switch
          checked={params.row.mappingComplete || false}
          onChange={(e) => {
            e.stopPropagation();
            if (onToggleMappingComplete) {
              onToggleMappingComplete(params.row);
            }
          }}
          onClick={(e) => e.stopPropagation()}
          color="success"
          size="small"
        />
      </Tooltip>
    ),
  },
  {
    field: "actions",
    type: "actions",
    flex: 1,
    align: "right",
    maxWidth: 300,
    getActions: ({ row }: { row: ClientInformation }) => [
      <ActionButton
        key="edit"
        onClick={(e) => {
          e.stopPropagation();
          onEdit(row);
        }}
      >
        <EditIcon fontSize="small" />
      </ActionButton>,
      <ActionButton
        key="delete"
        onClick={(e) => {
          e.stopPropagation();
          onDelete(row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </ActionButton>,
    ],
  },
];

export const pageTitle = "Client Information";
